<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/system")
            i.fa.fa-cogs
            span.ml-1 {{ $t("ui.system") }}
        b-breadcrumb-item
          router-link(to="/system/setting")
            i.fa.fa-sliders-h
            span.ml-1 {{ $t("ui.settings") }}
    div.row.mb-5
      div.col-md-4
        b-tabs
          b-tab(:title="$t('ui.password')")
            div.card-group
              changePwd
      div.col-md-4
        b-tabs
          b-tab(:title="$t('ui.otp')")
            div.card-group
              Otp2fa
</template>

<script>
import changePwd from "@/components/changePwd.vue";
import Otp2fa from "@/components/otp2fa.vue";

export default {
  components: {
    changePwd,
    Otp2fa
  },
  computed: {
    is2faBound() {
      const twoFactorStatus = this.$store.getters.get2faValidated;
      return twoFactorStatus === true || twoFactorStatus === 1;
    }
  }
};
</script>
